<template>
  <div class="context">
    <div class="cardheard">
      <div class="item">
        <el-input placeholder="请输入姓名" v-model="req.query.name" />
      </div>
   
      <div class="item">
        <el-date-picker v-model="time" type="daterange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div class="item">
        <el-button   type="primary" @click="clear">清空</el-button>
      </div>
      <div class="item">
        <el-button type="primary" @click="selectByQuery">查询</el-button>
      </div>

      <div class="item">
        <el-button type="primary" @click="showjqm()">远程开机</el-button>
      </div>

      
    </div>
    <template>
      <el-table v-model="data" :data="data" style="width: 100%" height="80%" v-loading="loading">
        <el-table-column type="index" width="50">
        </el-table-column>

        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="身份证号">
          <template slot-scope="scope">
            <span>{{ scope.row.card }}</span>
          </template>
        </el-table-column>

        <el-table-column label="ip/mac">
          <template slot-scope="scope">
            <span>{{ scope.row.ip }}</span>
          </template>
        </el-table-column>



        <el-table-column label="上机时间" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>


        <el-table-column label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.homeName }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作" width="300">

          <template slot-scope="scope">
            <el-button type="text" @click="updateUser(scope.row)" size="small">修改</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <div slot="footer" class="dialog-footer">
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :total="10000">
          </el-pagination>
        </div>
      </div>


    </template>
    <template>
    </template>


    <div v-if="modelShow">
      <jqmAdmin :dialogShow="modelShow" ref="userModel" @pushdata="pushdata" @modelChange="userShowChange" />
    </div>
  </div>
</template>

<script>
import store from '@/store/'
import jqmAdmin from '../components/jqmAdmin.vue'

export default {
  data() {
    return {
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        time: '',
      loading: true,
      req: {
        parma: "",
        pageIndex: 0,
        pageCount: 10,
        query:{
          sysUserId:"",
          name:""
        }
      },
      data: [],
      modelShow: false
    };
  },
  mounted() {
    this.req.query.sysUserId=this.$store.state.user.user.id
    this.pushdata();
  },
  methods: {
    showjqm(){
      this.modelShow=true
    },
    reset() {
      this.time=[]
      this.req= {
        parma: "",
        pageIndex: 0,
        pageCount: 10,
        query:{
          sysUserId:"",
          name:""
        }
      }
      this.req.query.sysUserId=this.$store.state.user.user.id
    },
    clear() {
    
      this.reset()
      this.pushdata()
    },
    selectByQuery() {
      if(this.time){
        this.req.startTime=this.time[0]
        this.req.endTime=this.time[1]
      }
      this.req.pageIndex = 0;
      this.pushdata();
    },
    updateUser(row) {
      this.modelShow = true,
        setTimeout(() => {
          this.$refs['userModel'].init(row.id)//用$refs赋值调用子组件的init方法
        }, 500)
    },
    userShowChange(visible) {
      this.modelShow = visible
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      if (val != 1) {
        var statcount = (val - 1) * this.req.pageCount;
        this.req.pageIndex = statcount;
        console.log("当前开始index--" + statcount);
      }
      else {
        this.req.pageIndex = 0;
        console.log("当前开始index--" + statcount);
      }
      console.log(this.req);
      this.pushdata();
    },
    pushdata() {
  
      var that = this;
      that.$axios
        .post("/api2/business/showAllRecordByPage", this.req)
        .then(function (response) {
          that.loading = false
          that.data = response.data.data;
        });
    }
  },
  components: { jqmAdmin }
}
</script>
<style>
.item{
  margin-left: 10px;
}
</style>
